import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'kon-dynamic-form-tabs',
  imports: [CommonModule, FormlyModule, TabsModule],
  template: `
    <p-tabs [ngClass]="field.className" [(value)]="activeIndex">
      <p-tablist>
        @for (tab of field.fieldGroup; track tab; let i = $index) {
          <p-tab [value]="i">
            {{ tab.props?.['tab'] ?? tab.props?.label ?? '' }}
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (tab of field.fieldGroup; track tab; let i = $index) {
          <p-tabpanel [ngClass]="field.fieldGroupClassName" [value]="i">
            <formly-field [field]="tab"></formly-field>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTabsTypeComponent extends FieldType {
  activeIndex = 0;

  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl?.valid === true;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }
}
